import React from 'react';
import { DeviceRenderer } from './objects/DeviceRenderer';

export const InternetWifi = () => {
  return <DeviceRenderer section="internet" />;
};
